import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { ICON_PATH_TOKEN } from '@shared/ui-shared';
import { GOOGLE_MAPS_INITIALIZER } from '../providers/google-map-initializer.provider';
import { appRoutes } from './app.routes';
import { errorHandlerInterceptor } from './interceptors/error-handler.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideHttpClient(withInterceptors([errorHandlerInterceptor])),
    // provideNoopAnimations(), // placeholder for Animations module, required by Angular Material
    provideAnimations(),
    /* It may be useful later when we have to use api call for the config 
    CASELLA_CONFIG_INITIALIZER,
    */
    GOOGLE_MAPS_INITIALIZER,
    { provide: ICON_PATH_TOKEN, useValue: 'icons' },
  ],
};
